import { render, staticRenderFns } from "./MySecretPrescriptionWrite.vue?vue&type=template&id=746b0402"
import script from "./MySecretPrescriptionWrite.vue?vue&type=script&lang=js"
export * from "./MySecretPrescriptionWrite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports